// Calling Bootstrap Without it Formating should create problems
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

// Login In
import SignIn from "./login/login.js";

// React Core
import { Routes, Route } from "react-router-dom";
import { React } from "react";
import PublicRoutes from "./protection/publicRoutes.js";
import usePoAdmin from "./protection/usePoAdmin.js";
import useConsigneeRoutes from "./protection/useConsigneeRoutes.js";
import { USER_RIGHTS } from "./constants/constants.js";
import { useAuthentication } from "./customHook/useAuthentecation.js";
import useCOSG from "./protection/useCOSG.js";
import useSSEADM from "./protection/useSSEADM.js";
import useAccounts from "./protection/useAccounts.js";
import useSSEI from "./protection/useSSEI.js";
import NewYearOverlay from "./components/NewYearBanner/NewYearOverlay.jsx";
function App() {
  const { auth } = useAuthentication();

  const adminRoutes = usePoAdmin();
  const consigneeRoutes = useConsigneeRoutes();
  const cosgRoutes = useCOSG();
  const sseadmRoutes = useSSEADM();
  const accountRoutes = useAccounts();
  const sseiRoutes = useSSEI();

  return (
    <>
    <NewYearOverlay />
      <Routes>
        
        {auth?.userrights === USER_RIGHTS.ADMIN && adminRoutes}
        {auth?.userrights === USER_RIGHTS.CONSIGNEE && consigneeRoutes}
        {auth?.userrights === USER_RIGHTS.COSG && cosgRoutes}
        {auth?.userrights === USER_RIGHTS.SSE_ADMIN && sseadmRoutes}
        {auth?.userrights === USER_RIGHTS.ACCOUNTS && accountRoutes}
        {auth?.userrights === USER_RIGHTS.SSEI && sseiRoutes}
        <Route element={<PublicRoutes />}>
          <Route
            // index
           
            element={
              // {/* LOGIN */}
              <SignIn />
            }
            path="/"
          />
        </Route>
      </Routes>
    </>
  );
}

export default App;
